import { DocumentPickerAsset } from "expo-document-picker";
import { ImagePickerAsset } from "expo-image-picker";

export type visibility = "Public" | "Group";
export enum eventRegistrationPolicy {
  NONE = "None",
  REQUIRED = "Required",
  INVITE_ONLY = "Invite",
}
export type InsertEventInput = {
  title: string;
  description: string;
  singleDay: boolean;
  startTime: string;
  endTime: string;
  locationName: string;
  locationLat: number;
  locationLng: number;
  categoryIds: string[];
  coverImage?: string;
  visibility: visibility;
  registrationPolicy: eventRegistrationPolicy;
  capacity?: number | null;
  groupIds?: string[];
  attachmentUrls?: string[];
  Tags: string[];
};

export type InsertEventResponse = {
  insertevent: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

export type Step1FormValues = {
  title: string;
  description: string;
  singleDay: boolean;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  locationName: string;
  locationLat: number;
  locationLng: number;
  categoryIds: string[];
  coverImage?: ImagePickerAsset | null;
  attachments?: DocumentPickerAsset[];
  existingAttachments?: string[];
};

export type Step2FormValues = {
  visibility: visibility;
  registrationPolicy: eventRegistrationPolicy;
  capacity?: number | null;
  groupIds?: string[];
};

export type EventOrganizerSnapshot = {
  firstName: string;
  lastName: string;
  email: string;
  profileImageUrl?: string;
};
export type EventParticipantSnapshot = {
  firstName: string;
  lastName: string;
  email: string;
  profileImageUrl?: string;
};

// Listing
export type EventItem = {
  ItemId: string;
  CreatedDate: string;
  CreatedBy: string;
  LastUpdatedDate: string;
  LastUpdatedBy: string;
  Language: string;
  OrganizationIds: string[];
  Tags: string[];
  DeletedDate: string | null;
  title: string;
  description: string;
  singleDay: boolean;
  startTime: string;
  endTime: string;
  locationName: string;
  locationLat: number;
  locationLng: number;
  categoryIds: string[];
  coverImage: string | null;
  visibility: string;
  registrationPolicy: eventRegistrationPolicy;
  capacity: number;
  attachmentUrls: string[];
  eventOrganizerSnapshot: EventOrganizerSnapshot | null;
  groupIds: string[];
};

export type GetEventsResponse = {
  getevents: {
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    items: EventItem[];
  };
};

export type GetEventsInput = {
  filter: string;
  sort: string;
  pageNo: number;
  pageSize: number;
};

export type DeleteEventResponse = {
  deleteevent: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

export type AttachmentItem =
  | { type: "existing"; url: string }
  | { type: "new"; file: DocumentPickerAsset };

// RSVP
export enum RSVPStatus {
  GOING = "Going",
  WAITING = "Waiting",
}

export type RSVPParticipantSnapshot = {
  firstName: string;
  lastName: string;
  email: string;
  profileImageUrl?: string;
};

export type RSVPItem = {
  ItemId: string;
  CreatedDate: string;
  CreatedBy: string;
  eventId: string;
  status: RSVPStatus;
  eventParticipantSnapshot: RSVPParticipantSnapshot;
};
export type GetRSVPsResponse = {
  getRSVPs: {
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    items: RSVPItem[];
  };
};

export type InsertRSVPResponse = {
  insertRSVP: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

export type UpdateRSVPResponse = {
  updateRSVP: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

export type DeleteRSVPResponse = {
  deleteRSVP: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

// Event Gallery
export type EventGalleryItem = {
  ItemId: string;
  CreatedDate: string;
  CreatedBy: string;
  LastUpdatedDate: string;
  LastUpdatedBy: string;
  Language: string | null;
  OrganizationIds: string[];
  Tags: string[];
  DeletedDate: string | null;
  eventId: string;
  imageUrl: string;
};

export type GetEventGalleryResponse = {
  geteventgallerys: {
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    items: EventGalleryItem[];
  };
};

export type InsertEventGalleryResponse = {
  inserteventgallery: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};

export type DeleteEventGalleryResponse = {
  deleteeventgallery: {
    acknowledged: boolean;
    totalImpactedData: number;
    itemId: string;
  };
};
